import React, { useState, useRef, useMemo, useEffect } from 'react';
import { FiX, FiDownload, FiBook, FiFileText, FiLayout, FiCheck, FiChevronDown, FiUpload, FiTrash2, FiBookOpen, FiBarChart2, FiClipboard, FiType, FiMaximize2, FiImage, FiMinus } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../../../hooks/AuthContext';

// ═══ CHAPTER ICONS ═══
const CHAPTER_ICONS = {
  briefcase: { path: 'M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2', cat: 'Negocios' },
  trending: { path: 'M23 6l-9.5 9.5-5-5L1 18M23 6h-6m6 0v6', cat: 'Negocios' },
  dollar: { path: 'M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6', cat: 'Negocios' },
  piechart: { path: 'M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z', cat: 'Negocios' },
  book: { path: 'M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5V4.5A2.5 2.5 0 016.5 2H20v20H6.5A2.5 2.5 0 014 19.5z', cat: 'Educacion' },
  graduation: { path: 'M22 10l-10-6L2 10l10 6 10-6zM6 12v5c3 3 9 3 12 0v-5', cat: 'Educacion' },
  pen: { path: 'M12 19l7-7 3 3-7 7-3-3zM18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5zM2 2l7.586 7.586', cat: 'Educacion' },
  code: { path: 'M16 18l6-6-6-6M8 6l-6 6 6 6', cat: 'Tecnologia' },
  monitor: { path: 'M2 3h20v14H2zM8 21h8M12 17v4', cat: 'Tecnologia' },
  cpu: { path: 'M6 6h12v12H6zM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3', cat: 'Tecnologia' },
  globe: { path: 'M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2a15 15 0 014 10 15 15 0 01-4 10M12 2a15 15 0 00-4 10 15 15 0 004 10', cat: 'Tecnologia' },
  phone: { path: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z', cat: 'Comunicacion' },
  mail: { path: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6', cat: 'Comunicacion' },
  message: { path: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z', cat: 'Comunicacion' },
  target: { path: 'M12 2a10 10 0 100 20 10 10 0 000-20zM12 6a6 6 0 100 12 6 6 0 000-12zM12 10a2 2 0 100 4 2 2 0 000-4z', cat: 'Estrategia' },
  flag: { path: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7', cat: 'Estrategia' },
  compass: { path: 'M12 2a10 10 0 100 20 10 10 0 000-20zM16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z', cat: 'Estrategia' },
  users: { path: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75', cat: 'Personas' },
  heart: { path: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z', cat: 'Personas' },
  settings: { path: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z', cat: 'Proceso' },
  layers: { path: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5', cat: 'Proceso' },
  refresh: { path: 'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15', cat: 'Proceso' },
  database: { path: 'M12 2C6.48 2 2 3.79 2 6v12c0 2.21 4.48 4 10 4s10-1.79 10-4V6c0-2.21-4.48-4-10-4zM2 6c0 2.21 4.48 4 10 4s10-1.79 10-4M2 12c0 2.21 4.48 4 10 4s10-1.79 10-4', cat: 'Datos' },
  barchart: { path: 'M12 20V10M18 20V4M6 20v-4', cat: 'Datos' },
  shield: { path: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', cat: 'Seguridad' },
  lock: { path: 'M5 11h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2zM7 11V7a5 5 0 0110 0v4', cat: 'Seguridad' },
  lightbulb: { path: 'M9 18h6M10 22h4M12 2a7 7 0 00-4 12.7V17h8v-2.3A7 7 0 0012 2z', cat: 'Creatividad' },
  star: { path: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z', cat: 'Creatividad' },
  activity: { path: 'M22 12h-4l-3 9L9 3l-3 9H2', cat: 'Salud' },
  truck: { path: 'M1 3h15v13H1zM16 8h4l3 3v5h-7V8zM5.5 21a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM18.5 21a2.5 2.5 0 100-5 2.5 2.5 0 000 5z', cat: 'Logistica' },
  packageIcon: { path: 'M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12', cat: 'Logistica' },
  clock: { path: 'M12 2a10 10 0 100 20 10 10 0 000-20zM12 6v6l4 2', cat: 'Tiempo' },
  calendar: { path: 'M3 4h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1zM16 2v4M8 2v4M2 10h20', cat: 'Tiempo' },
  file: { path: 'M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9zM13 2v7h7', cat: 'Documentos' },
  clipboard: { path: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2M9 2h6a1 1 0 011 1v1a1 1 0 01-1 1H9a1 1 0 01-1-1V3a1 1 0 011-1z', cat: 'Documentos' },
  award: { path: 'M12 15a7 7 0 100-14 7 7 0 000 14zM8.21 13.89L7 23l5-3 5 3-1.21-9.12', cat: 'Marketing' },
  zap: { path: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z', cat: 'Marketing' },
};

const ChapterIcon = ({ iconKey, size = 80, color: c }) => {
  const icon = CHAPTER_ICONS[iconKey];
  if (!icon) return null;
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8 }}><path d={icon.path} /></svg>;
};

const autoSelectIcon = (t) => {
  t = (t || '').toLowerCase();
  const m = { briefcase: ['negocio','empresa','comercial'], trending: ['crecimiento','tendencia','resultado','kpi'], dollar: ['precio','costo','financ','inversion','venta','presupuesto','pago'], piechart: ['analisis','estadistic','metrica'], book: ['introduccion','capitulo','lectura','guia'], graduation: ['curso','capacitacion','formacion','aprendizaje'], pen: ['escrib','redaccion','nota'], code: ['codigo','programacion','desarrollo','software'], monitor: ['pantalla','interfaz','aplicacion','web'], globe: ['global','internacional','internet','digital'], phone: ['telefon','llamada','contacto','movil','celular'], mail: ['correo','email','comunicacion'], target: ['objetivo','meta','logro','proposito'], flag: ['hito','fase','etapa','avance'], compass: ['estrategia','direccion','plan','ruta'], users: ['equipo','personal','colaborador','cliente'], heart: ['satisfaccion','experiencia','bienestar'], settings: ['configuracion','proceso','metodo','procedimiento'], layers: ['estructura','arquitectura','componente'], refresh: ['mejora','optimizacion','actualizacion','cambio'], database: ['dato','base de datos','informacion'], barchart: ['reporte','informe','resumen','dashboard'], shield: ['seguridad','proteccion','privacidad'], lock: ['acceso','autenticacion','control'], lightbulb: ['idea','innovacion','creativ','solucion'], star: ['excelencia','calidad','destacado','mejor'], activity: ['salud','medic','diagnostico'], truck: ['envio','logistic','transporte','entrega'], clock: ['tiempo','plazo','horario','preparacion'], calendar: ['fecha','calendario','programa','evento'], file: ['archivo','documento','formulario'], clipboard: ['lista','checklist','verificacion','revision'], award: ['premio','reconocimiento','exito'], zap: ['rapido','energia','impulso','accion','impacto','cierre'] };
  for (const [icon, words] of Object.entries(m)) { if (words.some(w => t.includes(w))) return icon; }
  return 'book';
};

// ═══ CONFIG ═══
const FONTS = [
  { id: 'inter', label: 'Inter', family: "'Inter', system-ui, sans-serif", google: 'Inter:wght@400;600;700;800' },
  { id: 'georgia', label: 'Georgia', family: "'Georgia', 'Times New Roman', serif", google: null },
  { id: 'merriweather', label: 'Merriweather', family: "'Merriweather', serif", google: 'Merriweather:wght@400;700;900' },
  { id: 'playfair', label: 'Playfair Display', family: "'Playfair Display', serif", google: 'Playfair+Display:wght@400;700;800;900' },
  { id: 'roboto', label: 'Roboto', family: "'Roboto', sans-serif", google: 'Roboto:wght@400;500;700;900' },
  { id: 'lato', label: 'Lato', family: "'Lato', sans-serif", google: 'Lato:wght@400;700;900' },
  { id: 'montserrat', label: 'Montserrat', family: "'Montserrat', sans-serif", google: 'Montserrat:wght@400;600;700;800;900' },
  { id: 'opensans', label: 'Open Sans', family: "'Open Sans', sans-serif", google: 'Open+Sans:wght@400;600;700;800' },
];
const TEMPLATES = [
  { id: 'ebook', label: 'Ebook', Icon: FiBook }, { id: 'manual', label: 'Manual', Icon: FiClipboard },
  { id: 'guide', label: 'Guia', Icon: FiBookOpen }, { id: 'report', label: 'Reporte', Icon: FiBarChart2 },
];
const COLORS = [
  { id: 'blue', primary: '#1e40af', secondary: '#3b82f6', bg: '#eff6ff', accent: '#60a5fa', dark: '#0f172a', name: 'Azul' },
  { id: 'indigo', primary: '#3730a3', secondary: '#6366f1', bg: '#eef2ff', accent: '#818cf8', dark: '#1e1b4b', name: 'Indigo' },
  { id: 'emerald', primary: '#065f46', secondary: '#10b981', bg: '#ecfdf5', accent: '#34d399', dark: '#022c22', name: 'Esmeralda' },
  { id: 'amber', primary: '#92400e', secondary: '#f59e0b', bg: '#fffbeb', accent: '#fbbf24', dark: '#451a03', name: 'Ambar' },
  { id: 'rose', primary: '#9f1239', secondary: '#f43f5e', bg: '#fff1f2', accent: '#fb7185', dark: '#4c0519', name: 'Rosa' },
  { id: 'slate', primary: '#1e293b', secondary: '#64748b', bg: '#f8fafc', accent: '#94a3b8', dark: '#0f172a', name: 'Clasico' },
  { id: 'orange', primary: '#9a3412', secondary: '#f97316', bg: '#fff7ed', accent: '#fb923c', dark: '#431407', name: 'Naranja' },
  { id: 'teal', primary: '#115e59', secondary: '#14b8a6', bg: '#f0fdfa', accent: '#2dd4bf', dark: '#042f2e', name: 'Teal' },
];
const COVER_DESIGNS = [
  { id: 'minimal', label: 'Minimal' }, { id: 'dark', label: 'Oscuro' }, { id: 'gradient', label: 'Gradiente' },
  { id: 'geometric', label: 'Geometrico' }, { id: 'lateral', label: 'Lateral' }, { id: 'corporate', label: 'Corporativo' },
];
const MARGINS = [
  { id: 'narrow', label: 'Estrecho', value: '25mm' }, { id: 'normal', label: 'Normal', value: '20mm' }, { id: 'wide', label: 'Amplio', value: '15mm' },
];
const FOOTER_DESIGNS = [
  { id: 'none', label: 'Sin pie' }, { id: 'simple', label: 'Simple' }, { id: 'line', label: 'Con linea' },
  { id: 'colored', label: 'Color' }, { id: 'branded', label: 'Con logo' },
];
const CHAPTER_LAYOUTS = [
  { id: 'default', label: 'Clasico' }, { id: 'icon-left', label: 'Icono lateral' },
  { id: 'highlight', label: 'Destacado' }, { id: 'separator', label: 'Con separadora' },
];
const PAGE_FORMATS = [
  { id: 'a4', label: 'A4', w: '210mm', h: '297mm', pdf: 'a4' },
  { id: 'letter', label: 'Carta', w: '216mm', h: '279mm', pdf: 'letter' },
  { id: 'a5', label: 'A5', w: '148mm', h: '210mm', pdf: 'a5' },
];
const LINE_HEIGHTS = [
  { id: '1.4', label: '1.0' }, { id: '1.6', label: '1.5' }, { id: '1.9', label: '2.0' },
];
const FONT_SIZES = [
  { id: '12', label: '12px' }, { id: '13', label: '13px' }, { id: '14', label: '14px' }, { id: '15', label: '15px' },
];
const DECORATIONS = [
  { id: 'section-lines', label: 'Lineas entre secciones' },
  { id: 'big-numbers', label: 'Numeros grandes' },
  { id: 'alt-backgrounds', label: 'Fondos alternos' },
  { id: 'borders', label: 'Bordes decorativos' },
];

// ═══ COVER RENDERERS ═══
const renderCover = (design, { title, subtitle, authorName, color, fontFamily, logoUrl, chapters, totalWords, readingTime, tpl, pageW, pageH }) => {
  const logoImg = logoUrl ? <img src={logoUrl} alt="Logo" style={{ maxHeight: '40px', maxWidth: '180px', objectFit: 'contain' }} crossOrigin="anonymous" /> : null;
  const statsRow = <div style={{ display: 'flex', gap: '24px', fontSize: '11px', opacity: 0.7 }}><span>{chapters.length} capitulos</span><span>{totalWords.toLocaleString()} palabras</span><span>~{readingTime} min</span></div>;
  const coverStyle = { width: pageW, height: pageH, position: 'relative', overflow: 'hidden', boxSizing: 'border-box' };

  switch (design) {
    case 'minimal': return (
      <div style={{ ...coverStyle, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '60px 50px', textAlign: 'center', background: '#fff' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '6px', background: color.secondary }} />
        {logoImg && <div style={{ marginBottom: '50px' }}>{logoImg}</div>}
        <div style={{ width: '80px', height: '80px', borderRadius: '20px', background: color.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}><tpl.Icon size={36} color={color.secondary} /></div>
        <h1 style={{ fontSize: '34px', fontWeight: 800, color: color.primary, lineHeight: 1.2, marginBottom: '16px', maxWidth: '500px', fontFamily }}>{title || 'Sin titulo'}</h1>
        {subtitle && <p style={{ fontSize: '16px', color: '#64748b', maxWidth: '400px', lineHeight: 1.5 }}>{subtitle}</p>}
        <div style={{ width: '60px', height: '3px', background: color.secondary, borderRadius: '2px', margin: '20px 0' }} />
        <p style={{ fontSize: '15px', color: '#64748b' }}>{authorName || 'Autor'}</p>
        <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '6px' }}>{new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long' })}</p>
        <div style={{ marginTop: '40px' }}>{statsRow}</div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '6px', background: color.secondary }} />
      </div>);
    case 'dark': return (
      <div style={{ ...coverStyle, display: 'flex', flexDirection: 'column', background: '#0a0a0a', color: '#fff' }}>
        <div style={{ padding: '40px 50px 0' }}>{logoImg || <div style={{ fontSize: '18px', fontWeight: 700, letterSpacing: '1px' }}>DOCUMENTO</div>}</div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '40px 50px' }}>
          <h1 style={{ fontSize: '48px', fontWeight: 900, lineHeight: 1.1, marginBottom: '24px', textTransform: 'uppercase', fontFamily }}>{title || 'Sin titulo'}</h1>
          {subtitle && <p style={{ fontSize: '18px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>{subtitle}</p>}
          <p style={{ fontSize: '14px', fontWeight: 600, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '2px', marginTop: '16px' }}>{tpl.label.toUpperCase()}</p>
        </div>
        <div style={{ height: '35%', position: 'relative' }}><div style={{ position: 'absolute', inset: 0, background: `linear-gradient(135deg, ${color.dark}, ${color.primary}, ${color.secondary})`, opacity: 0.4 }} /></div>
        <div style={{ position: 'absolute', bottom: '30px', left: '50px', right: '50px', display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>{authorName || 'Autor'}</span><span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>{new Date().getFullYear()}</span></div>
      </div>);
    case 'gradient': return (
      <div style={{ ...coverStyle, display: 'flex', flexDirection: 'column', background: `linear-gradient(180deg, ${color.dark} 0%, ${color.primary} 40%, ${color.secondary} 100%)`, color: '#fff' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '60px 50px', position: 'relative', zIndex: 1 }}>
          {logoImg && <div style={{ marginBottom: '40px' }}>{logoImg}</div>}
          <h1 style={{ fontSize: '46px', fontWeight: 900, lineHeight: 1.1, marginBottom: '20px', textTransform: 'uppercase', fontFamily }}>{title || 'Sin titulo'}</h1>
          <div style={{ width: '80px', height: '4px', background: 'rgba(255,255,255,0.5)', marginBottom: '20px' }} />
          {subtitle && <p style={{ fontSize: '16px', fontWeight: 600, color: 'rgba(255,255,255,0.85)', textTransform: 'uppercase', letterSpacing: '1px', maxWidth: '450px' }}>{subtitle}</p>}
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '2px', marginTop: '20px' }}>ELABORADO POR {(authorName || 'Autor').toUpperCase()}</p>
        </div>
      </div>);
    case 'geometric': return (
      <div style={{ ...coverStyle, display: 'flex', flexDirection: 'column', background: '#fff' }}>
        <div style={{ padding: '40px 50px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', zIndex: 2, position: 'relative' }}>
          {logoImg || <div style={{ fontSize: '18px', fontWeight: 700, color: color.primary }}>DOCUMENTO</div>}
          {subtitle && <p style={{ fontSize: '11px', color: '#64748b', maxWidth: '250px', textAlign: 'right', lineHeight: 1.5, fontStyle: 'italic' }}>{subtitle}</p>}
        </div>
        <div style={{ padding: '60px 50px', zIndex: 2, position: 'relative' }}><h1 style={{ fontSize: '44px', fontWeight: 900, color: color.primary, lineHeight: 1.1, textTransform: 'uppercase', fontFamily }}>{title || 'Sin titulo'}</h1></div>
        <div style={{ flex: 1, position: 'relative' }}>
          <svg style={{ position: 'absolute', top: '10%', left: '30%', width: '200px', height: '200px' }} viewBox="0 0 200 200"><rect x="30" y="30" width="140" height="140" fill={color.secondary} transform="rotate(45,100,100)" opacity="0.9" /></svg>
          <svg style={{ position: 'absolute', top: '5%', right: 0, width: '250px', height: '400px' }} viewBox="0 0 250 400"><polygon points="50,0 250,0 250,400 150,300" fill={color.dark} opacity="0.9" /></svg>
        </div>
        <div style={{ position: 'absolute', bottom: '30px', left: '50px', fontSize: '120px', fontWeight: 900, color: color.secondary, opacity: 0.12, lineHeight: 1, fontFamily }}>{new Date().getFullYear()}</div>
      </div>);
    case 'lateral': return (
      <div style={{ ...coverStyle, display: 'flex', background: '#fff' }}>
        <div style={{ width: '45%', background: `linear-gradient(180deg, ${color.primary}, ${color.dark})`, padding: '50px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ position: 'relative', zIndex: 1 }}>
            {logoImg && <div style={{ marginBottom: '40px' }}>{logoImg}</div>}
            <h1 style={{ fontSize: '36px', fontWeight: 900, color: '#fff', lineHeight: 1.15, textTransform: 'uppercase', marginBottom: '20px', fontFamily }}>{title || 'Sin titulo'}</h1>
            <div style={{ width: '60px', height: '3px', background: color.accent, marginBottom: '20px' }} />
            {subtitle && <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.5 }}>{subtitle}</p>}
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '2px', marginTop: '16px' }}>{(authorName || 'Autor').toUpperCase()}</p>
          </div>
        </div>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '100px', height: '100px', borderRadius: '24px', background: color.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><tpl.Icon size={44} color={color.secondary} /></div>
        </div>
      </div>);
    case 'corporate': return (
      <div style={{ ...coverStyle, display: 'flex', flexDirection: 'column', background: '#fff' }}>
        <div style={{ background: color.primary, padding: '30px 50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {logoImg || <div style={{ fontSize: '16px', fontWeight: 700, color: '#fff' }}>DOCUMENTO</div>}
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.7)' }}>{new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long' })}</span>
        </div>
        <div style={{ height: '4px', background: color.secondary }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '60px 50px' }}>
          <div style={{ borderLeft: `4px solid ${color.secondary}`, paddingLeft: '24px' }}>
            <p style={{ fontSize: '12px', color: color.secondary, textTransform: 'uppercase', letterSpacing: '3px', fontWeight: 600, marginBottom: '16px' }}>{tpl.label}</p>
            <h1 style={{ fontSize: '38px', fontWeight: 800, color: color.primary, lineHeight: 1.2, marginBottom: '20px', fontFamily }}>{title || 'Sin titulo'}</h1>
            {subtitle && <p style={{ fontSize: '15px', color: '#64748b', lineHeight: 1.6, maxWidth: '450px' }}>{subtitle}</p>}
          </div>
        </div>
        <div style={{ padding: '20px 50px', borderTop: '1px solid #e2e8f0' }}><span style={{ fontSize: '12px', color: '#94a3b8' }}>{authorName || 'Autor'}</span></div>
      </div>);
    default: return null;
  }
};

// ═══ MAIN COMPONENT ═══
const EbookPreview = ({ isOpen, onClose, title, content, authorName }) => {
  const { user } = useAuth();
  const [template, setTemplate] = useState('ebook');
  const [colorScheme, setColorScheme] = useState('slate');
  const [coverDesign, setCoverDesign] = useState('minimal');
  const [footerDesign, setFooterDesign] = useState('line');
  const [chapterLayout, setChapterLayout] = useState('default');
  const [showChapterIcons, setShowChapterIcons] = useState(true);
  const [fontId, setFontId] = useState('inter');
  const [marginId, setMarginId] = useState('normal');
  const [pageFormat, setPageFormat] = useState('a4');
  const [lineHeight, setLineHeight] = useState('1.6');
  const [fontSize, setFontSize] = useState('13');
  const [decorations, setDecorations] = useState([]);
  const [showCover, setShowCover] = useState(true);
  const [showTOC, setShowTOC] = useState(true);
  const [subtitle, setSubtitle] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [chapterIcons, setChapterIcons] = useState({});
  const [editingIcon, setEditingIcon] = useState(null);
  const previewRef = useRef(null);
  const logoInputRef = useRef(null);

  const color = COLORS.find(c => c.id === colorScheme) || COLORS[5];
  const tpl = TEMPLATES.find(t => t.id === template) || TEMPLATES[0];
  const font = FONTS.find(f => f.id === fontId) || FONTS[0];
  const margin = MARGINS.find(m => m.id === marginId) || MARGINS[1];
  const pgFmt = PAGE_FORMATS.find(p => p.id === pageFormat) || PAGE_FORMATS[0];
  const toggleDropdown = (name) => setActiveDropdown(prev => prev === name ? null : name);
  const toggleDecoration = (id) => setDecorations(prev => prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]);
  const hasDeco = (id) => decorations.includes(id);

  useEffect(() => {
    if (!isOpen) return;
    if (!document.getElementById('ebook-google-fonts')) {
      const link = document.createElement('link');
      link.id = 'ebook-google-fonts'; link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?${FONTS.filter(f => f.google).map(f => `family=${f.google}`).join('&')}&display=swap`;
      document.head.appendChild(link);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || !user?.uid) return;
    (async () => { try { setLogoUrl(await getDownloadURL(storageRef(getStorage(), `users/${user.uid}/ebook-logo`))); } catch {} })();
  }, [isOpen, user?.uid]);

  const { chapters, plainText } = useMemo(() => {
    if (!content) return { chapters: [], plainText: '' };
    const tmp = document.createElement('div'); tmp.innerHTML = content;
    const plainText = tmp.textContent || '', chapters = [];
    let cur = null, sec = null;
    const proc = (node) => {
      const tag = node.tagName?.toLowerCase(), text = node.textContent?.trim();
      if (!text) return;
      if (tag === 'h2' || (tag === 'div' && node.querySelector('h2'))) { const t = tag === 'h2' ? text : node.querySelector('h2')?.textContent?.trim(); if (t) { cur = { title: t, sections: [], content: [] }; chapters.push(cur); sec = null; return; } }
      if (tag === 'h3' || (tag === 'div' && node.querySelector('h3'))) { const t = tag === 'h3' ? text : node.querySelector('h3')?.textContent?.trim(); if (t && cur) { sec = { title: t, content: [] }; cur.sections.push(sec); return; } }
      const html = node.outerHTML || `<p>${text}</p>`;
      if (sec) sec.content.push(html); else if (cur) cur.content.push(html);
      else { if (!chapters.length || chapters[0]?.title !== 'Introduccion') { cur = { title: 'Introduccion', sections: [], content: [] }; chapters.unshift(cur); } chapters[0].content.push(html); }
    };
    for (const c of tmp.childNodes) { if (c.nodeType === 3) { const t = c.textContent?.trim(); if (t) (sec || cur)?.content.push(`<p>${t}</p>`); } else if (c.nodeType === 1) proc(c); }
    if (!chapters.length && plainText.trim()) chapters.push({ title: title || 'Documento', sections: [], content: [content] });
    return { chapters, plainText };
  }, [content, title]);

  const totalWords = useMemo(() => plainText.split(/\s+/).filter(w => w).length, [plainText]);
  const readingTime = Math.max(1, Math.ceil(totalWords / 200));
  const totalPages = (showCover ? 1 : 0) + (showTOC && chapters.length > 1 ? 1 : 0) + chapters.length;
  const getChapterIcon = (i, t) => chapterIcons[i] || autoSelectIcon(t);

  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0]; if (!file || !user?.uid) return;
    setUploadingLogo(true);
    try { const r = storageRef(getStorage(), `users/${user.uid}/ebook-logo`); await uploadBytes(r, file); setLogoUrl(await getDownloadURL(r)); toast.success('Logo guardado'); } catch { toast.error('Error'); }
    setUploadingLogo(false); if (logoInputRef.current) logoInputRef.current.value = '';
  };

  // ═══ PDF EXPORT - two-pass: cover fullbleed + content auto-paginated ═══
  const handleExportPDF = async () => {
    if (!previewRef.current) return;
    setExporting(true);
    try {
      const html2pdf = (await import('html2pdf.js')).default;
      const html2canvas = (await import('html2canvas')).default;

      const fmtMap = { a4: [210, 297], letter: [216, 279], a5: [148, 210] };
      const [pageWmm, pageHmm] = fmtMap[pageFormat] || fmtMap.a4;
      const marginMm = marginId === 'narrow' ? 15 : marginId === 'wide' ? 25 : 20;

      // Build export container: cover as fullbleed image + content auto-paginated
      const styleEl = document.createElement('style');
      styleEl.textContent = `
        .ebook-content img { max-width: 100%; border-radius: 6px; margin: 10px 0; }
        .ebook-content ul, .ebook-content ol { padding-left: 22px; margin: 8px 0; }
        .ebook-content li { margin-bottom: 4px; }
        .ebook-content strong, .ebook-content b { color: #1e293b; }
        .ebook-content blockquote { border-left: 3px solid #e2e8f0; padding-left: 14px; margin: 14px 0; color: #64748b; font-style: italic; }
        .ebook-content a { color: ${color.secondary}; text-decoration: underline; }
        .ebook-content h2, .ebook-content h3 { color: ${color.primary}; }
        .ebook-content p { margin-bottom: 6px; }
      `;

      const fullExportDiv = document.createElement('div');
      fullExportDiv.style.cssText = `font-family:${font.family}; font-size:${fontSize}px; line-height:${lineHeight}; color:#334155;`;
      fullExportDiv.appendChild(styleEl.cloneNode(true));

      // Add cover/separator pages as fixed-size images
      const allPages = previewRef.current.querySelectorAll('.ebook-preview-page');
      for (const page of allPages) {
        const isCover = page.classList.contains('ebook-cover-page');
        const isSeparator = page.classList.contains('ebook-separator-page');

        if (isCover || isSeparator) {
          // Render as image to preserve exact layout
          const canvas = await html2canvas(page, {
            scale: 3, useCORS: true, letterRendering: true, backgroundColor: '#ffffff',
            width: page.offsetWidth, height: page.offsetHeight,
          });
          const imgEl = document.createElement('img');
          imgEl.src = canvas.toDataURL('image/png');
          imgEl.style.cssText = `width:${pageWmm}mm; height:${pageHmm}mm; display:block; object-fit:cover;`;
          imgEl.className = 'html2pdf__page-break';
          fullExportDiv.appendChild(imgEl);
        } else {
          // Content - clone without fixed dimensions
          const clone = page.cloneNode(true);
          clone.style.cssText = 'box-shadow:none; border-radius:0; width:auto; min-height:auto; height:auto; overflow:visible; position:relative; padding:0; margin:0; background:#fff;';
          // Add page break before content sections
          if (fullExportDiv.children.length > 1) {
            clone.style.pageBreakBefore = 'always';
          }
          fullExportDiv.appendChild(clone);
        }
      }

      document.body.appendChild(fullExportDiv);

      await html2pdf().set({
        margin: 0,  // Cover needs 0 margins
        filename: `${title || 'documento'}.pdf`,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
        jsPDF: { unit: 'mm', format: pgFmt.pdf, orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'], before: '.html2pdf__page-break' },
      }).from(fullExportDiv).save();

      document.body.removeChild(fullExportDiv);
      toast.success('PDF descargado');
    } catch (err) { console.error('PDF export error:', err); toast.error('Error al exportar PDF'); }
    setExporting(false);
  };

  const handleCopyHTML = () => {
    if (!previewRef.current) return;
    const blob = new Blob([previewRef.current.innerHTML], { type: 'text/html' });
    navigator.clipboard.write([new ClipboardItem({ 'text/html': blob })]).then(() => toast.success('Copiado')).catch(() => { navigator.clipboard.writeText(previewRef.current.innerText); toast.success('Texto copiado'); });
  };

  if (!isOpen) return null;

  const fontFamily = font.family;
  const coverProps = { title, subtitle, authorName, color, fontFamily, logoUrl, chapters, totalWords, readingTime, tpl, pageW: pgFmt.w, pageH: pgFmt.h };

  const Dd = ({ name, label, icon: Icon, val, children }) => (
    <div>
      <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">{label}</label>
      <div className="relative">
        <button onClick={() => toggleDropdown(name)} className="w-full flex items-center justify-between bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-[12px] text-white/80 hover:bg-white/10">
          <span className="flex items-center gap-2">{Icon && <Icon size={13} />} {val}</span><FiChevronDown size={12} className="text-white/40" />
        </button>
        {activeDropdown === name && <div className="absolute top-full left-0 right-0 mt-1 bg-[#2f2f2f] border border-white/10 rounded-lg overflow-hidden z-10 max-h-[200px] overflow-y-auto">{children}</div>}
      </div>
    </div>);
  const Di = ({ sel, onClick, children }) => (
    <button onClick={onClick} className={`w-full flex items-center justify-between px-3 py-2 text-[12px] ${sel ? 'bg-white/10 text-white' : 'text-white/60 hover:bg-white/5'}`}>{children}{sel && <FiCheck size={12} />}</button>);

  const iconCategories = {};
  for (const [k, v] of Object.entries(CHAPTER_ICONS)) { if (!iconCategories[v.cat]) iconCategories[v.cat] = []; iconCategories[v.cat].push(k); }

  // Page style for preview
  const previewPageStyle = { width: pgFmt.w, background: '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', marginBottom: '16px', borderRadius: '2px', position: 'relative', overflow: 'hidden' };

  return (
    <div className="fixed inset-0 z-[120] flex" style={{ background: '#1a1a1a' }}>
      {/* ══ SIDEBAR ══ */}
      <div className="w-72 border-r border-white/10 flex flex-col shrink-0 overflow-y-auto" style={{ background: '#212121' }}>
        <div className="p-4 space-y-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2"><FiBook size={16} className="text-white/60" /><span className="text-sm font-bold text-white/90">Exportar</span></div>
            <button onClick={onClose} className="p-1 text-white/40 hover:text-white/80"><FiX size={18} /></button>
          </div>

          <Dd name="template" label="Plantilla" icon={tpl.Icon} val={tpl.label}>
            {TEMPLATES.map(t => <Di key={t.id} sel={template === t.id} onClick={() => { setTemplate(t.id); setActiveDropdown(null); }}><span className="flex items-center gap-2"><t.Icon size={14} />{t.label}</span></Di>)}
          </Dd>
          <Dd name="cover" label="Portada" icon={FiLayout} val={COVER_DESIGNS.find(d => d.id === coverDesign)?.label}>
            {COVER_DESIGNS.map(d => <Di key={d.id} sel={coverDesign === d.id} onClick={() => { setCoverDesign(d.id); setActiveDropdown(null); }}>{d.label}</Di>)}
          </Dd>
          <Dd name="layout" label="Layout capitulos" icon={FiLayout} val={CHAPTER_LAYOUTS.find(l => l.id === chapterLayout)?.label}>
            {CHAPTER_LAYOUTS.map(l => <Di key={l.id} sel={chapterLayout === l.id} onClick={() => { setChapterLayout(l.id); setActiveDropdown(null); }}>{l.label}</Di>)}
          </Dd>
          <Dd name="font" label="Tipografia" icon={FiType} val={<span style={{ fontFamily: font.family }}>{font.label}</span>}>
            {FONTS.map(f => <Di key={f.id} sel={fontId === f.id} onClick={() => { setFontId(f.id); setActiveDropdown(null); }}><span style={{ fontFamily: f.family }}>{f.label}</span></Di>)}
          </Dd>
          <Dd name="footer" label="Pie de pagina" icon={FiMinus} val={FOOTER_DESIGNS.find(d => d.id === footerDesign)?.label}>
            {FOOTER_DESIGNS.map(d => <Di key={d.id} sel={footerDesign === d.id} onClick={() => { setFooterDesign(d.id); setActiveDropdown(null); }}>{d.label}</Di>)}
          </Dd>
          <Dd name="pageformat" label="Formato pagina" val={pgFmt.label}>
            {PAGE_FORMATS.map(p => <Di key={p.id} sel={pageFormat === p.id} onClick={() => { setPageFormat(p.id); setActiveDropdown(null); }}>{p.label} ({p.w} x {p.h})</Di>)}
          </Dd>

          {/* Inline selectors row */}
          <div className="flex gap-2">
            <div className="flex-1">
              <label className="text-[9px] text-white/40 font-medium mb-1 block uppercase">Texto</label>
              <div className="flex gap-1">
                {FONT_SIZES.map(s => <button key={s.id} onClick={() => setFontSize(s.id)} className={`flex-1 py-1 rounded text-[9px] ${fontSize === s.id ? 'bg-white/15 text-white' : 'bg-white/5 text-white/40'}`}>{s.label}</button>)}
              </div>
            </div>
            <div className="flex-1">
              <label className="text-[9px] text-white/40 font-medium mb-1 block uppercase">Interlineado</label>
              <div className="flex gap-1">
                {LINE_HEIGHTS.map(l => <button key={l.id} onClick={() => setLineHeight(l.id)} className={`flex-1 py-1 rounded text-[9px] ${lineHeight === l.id ? 'bg-white/15 text-white' : 'bg-white/5 text-white/40'}`}>{l.label}</button>)}
              </div>
            </div>
          </div>

          {/* Color */}
          <div>
            <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Color</label>
            <div className="flex gap-1.5 flex-wrap">
              {COLORS.map(c => <button key={c.id} onClick={() => setColorScheme(c.id)} className={`w-7 h-7 rounded-lg border-2 transition-all ${colorScheme === c.id ? 'border-white scale-110' : 'border-transparent hover:scale-105'}`} style={{ background: c.secondary }} title={c.name} />)}
            </div>
          </div>

          {/* Margins */}
          <div>
            <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Margenes</label>
            <div className="flex gap-1.5">
              {MARGINS.map(m => <button key={m.id} onClick={() => setMarginId(m.id)} className={`flex-1 py-1.5 rounded-lg text-[10px] font-medium border ${marginId === m.id ? 'border-white/30 bg-white/10 text-white' : 'border-white/5 bg-white/5 text-white/50'}`}><FiMaximize2 size={10} className="mx-auto mb-0.5" />{m.label}</button>)}
            </div>
          </div>

          {/* Subtitle */}
          <div>
            <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Subtitulo</label>
            <input value={subtitle} onChange={e => setSubtitle(e.target.value)} placeholder="Descripcion breve..." className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-[12px] text-white/80 placeholder:text-white/25 focus:outline-none focus:border-white/20" />
          </div>

          {/* Logo */}
          <div>
            <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Logo</label>
            <input ref={logoInputRef} type="file" accept="image/*" onChange={handleLogoUpload} className="hidden" />
            {logoUrl ? (
              <div className="flex items-center gap-2">
                <div className="flex-1 bg-white/5 border border-white/10 rounded-lg p-2 flex items-center justify-center"><img src={logoUrl} alt="Logo" className="max-h-8 max-w-full object-contain" /></div>
                <button onClick={() => logoInputRef.current?.click()} className="p-2 bg-white/5 border border-white/10 rounded-lg text-white/50 hover:text-white/80"><FiUpload size={13} /></button>
                <button onClick={() => setLogoUrl('')} className="p-2 bg-white/5 border border-white/10 rounded-lg text-white/50 hover:text-red-400"><FiTrash2 size={13} /></button>
              </div>
            ) : (
              <button onClick={() => logoInputRef.current?.click()} disabled={uploadingLogo} className="w-full flex items-center justify-center gap-2 bg-white/5 border border-dashed border-white/15 rounded-lg py-3 text-[11px] text-white/40 hover:text-white/60">
                {uploadingLogo ? 'Subiendo...' : <><FiImage size={14} /> Subir logo</>}
              </button>
            )}
          </div>

          {/* Decorations */}
          <div>
            <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Decoraciones</label>
            <div className="space-y-1.5">
              {DECORATIONS.map(d => (
                <label key={d.id} className="flex items-center justify-between cursor-pointer group">
                  <span className="text-[11px] text-white/60 group-hover:text-white/80">{d.label}</span>
                  <div onClick={() => toggleDecoration(d.id)} className="w-8 rounded-full transition-colors relative cursor-pointer" style={{ background: hasDeco(d.id) ? color.secondary : 'rgba(255,255,255,0.15)', padding: '2px', height: '18px' }}>
                    <div className={`w-3.5 h-3.5 rounded-full bg-white shadow transition-transform ${hasDeco(d.id) ? 'translate-x-3.5' : 'translate-x-0'}`} />
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* Toggles */}
          <div className="space-y-2">
            <label className="text-[10px] text-white/40 font-medium mb-1 block uppercase tracking-wider">Opciones</label>
            {[{ label: 'Portada', value: showCover, set: setShowCover }, { label: 'Tabla de contenido', value: showTOC, set: setShowTOC }, { label: 'Iconos por capitulo', value: showChapterIcons, set: setShowChapterIcons }].map(opt => (
              <label key={opt.label} className="flex items-center justify-between cursor-pointer group">
                <span className="text-[11px] text-white/60 group-hover:text-white/80">{opt.label}</span>
                <div onClick={() => opt.set(!opt.value)} className="w-8 rounded-full transition-colors relative cursor-pointer" style={{ background: opt.value ? color.secondary : 'rgba(255,255,255,0.15)', padding: '2px', height: '18px' }}>
                  <div className={`w-3.5 h-3.5 rounded-full bg-white shadow transition-transform ${opt.value ? 'translate-x-3.5' : 'translate-x-0'}`} />
                </div>
              </label>
            ))}
          </div>

          {/* Chapter icons */}
          {showChapterIcons && chapters.length > 0 && (
            <div>
              <label className="text-[10px] text-white/40 font-medium mb-1.5 block uppercase tracking-wider">Iconos</label>
              <div className="space-y-1">
                {chapters.map((ch, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <button onClick={() => setEditingIcon(editingIcon === i ? null : i)} className="w-7 h-7 rounded-md bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 flex-shrink-0">
                      <ChapterIcon iconKey={getChapterIcon(i, ch.title)} size={16} color={color.secondary} />
                    </button>
                    <span className="text-[10px] text-white/50 truncate flex-1">{ch.title}</span>
                  </div>
                ))}
              </div>
              {editingIcon !== null && (
                <div className="mt-2 bg-white/5 border border-white/10 rounded-lg p-2 max-h-[150px] overflow-y-auto">
                  {Object.entries(iconCategories).map(([cat, keys]) => (
                    <div key={cat} className="mb-2">
                      <div className="text-[9px] text-white/30 uppercase mb-1">{cat}</div>
                      <div className="flex flex-wrap gap-1">
                        {keys.map(k => <button key={k} onClick={() => { setChapterIcons(p => ({ ...p, [editingIcon]: k })); setEditingIcon(null); }}
                          className={`w-7 h-7 rounded flex items-center justify-center ${getChapterIcon(editingIcon, chapters[editingIcon]?.title) === k ? 'bg-white/20 border border-white/30' : 'bg-white/5 hover:bg-white/10'}`}>
                          <ChapterIcon iconKey={k} size={14} color={color.secondary} />
                        </button>)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Bottom */}
        <div className="mt-auto p-4 space-y-3">
          <div className="bg-white/5 rounded-lg p-3 space-y-1.5">
            {[['Palabras', totalWords.toLocaleString()], ['Capitulos', chapters.length], ['Paginas', totalPages], ['Lectura', `~${readingTime} min`]].map(([k, v]) => (
              <div key={k} className="flex justify-between text-[10px]"><span className="text-white/40">{k}</span><span className="text-white/70 font-medium">{v}</span></div>
            ))}
          </div>
          <button onClick={handleExportPDF} disabled={exporting} className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-[12px] font-semibold text-white" style={{ background: color.secondary }}>
            <FiDownload size={14} />{exporting ? 'Generando...' : 'Descargar PDF'}
          </button>
          <button onClick={handleCopyHTML} className="w-full flex items-center justify-center gap-2 py-2 rounded-lg text-[12px] font-medium bg-white/10 text-white/70 hover:bg-white/15">
            <FiFileText size={13} />Copiar para Google Docs
          </button>
        </div>
      </div>

      {/* ══ PREVIEW ══ */}
      <div className="flex-1 overflow-y-auto p-8" style={{ background: '#2a2a2a' }}>
        <div ref={previewRef} className="mx-auto" style={{ width: pgFmt.w, fontFamily, fontSize: fontSize + 'px', lineHeight }}>

          {/* ── COVER ── */}
          {showCover && (
            <div className="ebook-preview-page ebook-cover-page" style={{ ...previewPageStyle, height: pgFmt.h }}>
              {renderCover(coverDesign, coverProps)}
            </div>
          )}

          {/* ── TOC ── */}
          {showTOC && chapters.length > 1 && (
            <div className="ebook-preview-page" style={{ ...previewPageStyle, padding: margin.value, minHeight: pgFmt.h, boxSizing: 'border-box' }}>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: color.primary, marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '10px', fontFamily }}><FiLayout size={20} />Tabla de Contenido</h2>
              <div style={{ borderTop: `2px solid ${color.bg}`, paddingTop: '20px' }}>
                {chapters.map((ch, idx) => (
                  <div key={idx} style={{ marginBottom: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {showChapterIcons && <ChapterIcon iconKey={getChapterIcon(idx, ch.title)} size={18} color={color.secondary} />}
                      <span style={{ fontSize: '14px', fontWeight: 700, color: color.secondary, minWidth: '20px' }}>{idx + 1}.</span>
                      <span style={{ fontSize: '14px', fontWeight: 600, color: '#1e293b' }}>{ch.title}</span>
                      <span style={{ flex: 1, borderBottom: '1px dotted #cbd5e1', margin: '0 8px', minWidth: '20px' }} />
                    </div>
                    {ch.sections.length > 0 && <div style={{ marginLeft: showChapterIcons ? '48px' : '28px', marginTop: '6px' }}>{ch.sections.map((s, si) => (
                      <div key={si} style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '3px' }}><span style={{ fontSize: '11px', color: '#94a3b8' }}>{idx + 1}.{si + 1}</span><span style={{ fontSize: '12px', color: '#64748b' }}>{s.title}</span></div>
                    ))}</div>}
                  </div>
                ))}
              </div>
              {/* Footer in TOC */}
              {footerDesign !== 'none' && <div style={{ marginTop: '40px', borderTop: '1px solid #e2e8f0', paddingTop: '8px', fontSize: '9px', color: '#94a3b8', display: 'flex', justifyContent: 'space-between' }}><span>{authorName}</span><span>Pagina {(showCover ? 2 : 1)} de {totalPages}</span></div>}
            </div>
          )}

          {/* ── CHAPTERS ── */}
          {chapters.map((chapter, chIdx) => {
            const iconKey = getChapterIcon(chIdx, chapter.title);
            const isEven = chIdx % 2 === 1;
            const pgNum = (showCover ? 1 : 0) + (showTOC && chapters.length > 1 ? 1 : 0) + chIdx + 1;

            return (
              <React.Fragment key={chIdx}>
                {/* Separator page */}
                {chapterLayout === 'separator' && (
                  <div className="ebook-preview-page ebook-separator-page" style={{ ...previewPageStyle, height: pgFmt.h, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '60px' }}>
                    {showChapterIcons && <div style={{ marginBottom: '40px', width: '120px', height: '120px', borderRadius: '30px', background: color.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ChapterIcon iconKey={iconKey} size={64} color={color.secondary} />
                    </div>}
                    {hasDeco('big-numbers') && <div style={{ fontSize: '100px', fontWeight: 900, color: color.secondary, opacity: 0.1, lineHeight: 1, position: 'absolute', top: '40px', right: '40px', fontFamily }}>{chIdx + 1}</div>}
                    <div style={{ fontSize: '13px', fontWeight: 700, color: color.secondary, textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '12px' }}>Capitulo {chIdx + 1}</div>
                    <h2 style={{ fontSize: '32px', fontWeight: 800, color: color.primary, lineHeight: 1.2, maxWidth: '400px', fontFamily }}>{chapter.title}</h2>
                    <div style={{ width: '60px', height: '3px', background: color.secondary, margin: '24px 0', borderRadius: '2px' }} />
                    {chapter.sections.length > 0 && <div style={{ color: '#94a3b8', fontSize: '12px' }}>{chapter.sections.map(s => s.title).join(' · ')}</div>}
                  </div>
                )}

                {/* Content page */}
                <div className="ebook-preview-page" style={{
                  ...previewPageStyle,
                  minHeight: pgFmt.h,
                  padding: margin.value,
                  boxSizing: 'border-box',
                  ...(hasDeco('alt-backgrounds') && isEven ? { background: color.bg } : {}),
                  ...(hasDeco('borders') ? { border: `2px solid ${color.bg}`, borderTop: `4px solid ${color.secondary}` } : {}),
                }}>
                  {/* Big chapter number watermark */}
                  {hasDeco('big-numbers') && chapterLayout !== 'separator' && (
                    <div style={{ position: 'absolute', top: '20px', right: '30px', fontSize: '120px', fontWeight: 900, color: color.secondary, opacity: 0.06, lineHeight: 1, fontFamily, pointerEvents: 'none' }}>{chIdx + 1}</div>
                  )}

                  {/* Chapter header by layout */}
                  {chapterLayout === 'icon-left' ? (
                    <div className="ebook-no-break" style={{ display: 'flex', gap: '24px', marginBottom: '28px', paddingBottom: '20px', borderBottom: `2px solid ${hasDeco('alt-backgrounds') && isEven ? 'rgba(0,0,0,0.06)' : color.bg}`, alignItems: 'center' }}>
                      {showChapterIcons && <div style={{ width: '80px', height: '80px', borderRadius: '20px', background: hasDeco('alt-backgrounds') && isEven ? '#fff' : color.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <ChapterIcon iconKey={iconKey} size={44} color={color.secondary} />
                      </div>}
                      <div>
                        <div style={{ fontSize: '11px', fontWeight: 700, color: color.secondary, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '4px' }}>Capitulo {chIdx + 1}</div>
                        <h2 style={{ fontSize: '22px', fontWeight: 800, color: color.primary, lineHeight: 1.3, fontFamily }}>{chapter.title}</h2>
                      </div>
                    </div>
                  ) : chapterLayout === 'highlight' ? (
                    <div className="ebook-no-break" style={{ marginBottom: '28px', padding: '30px', background: hasDeco('alt-backgrounds') && isEven ? '#fff' : color.bg, borderRadius: '12px', borderLeft: `4px solid ${color.secondary}`, position: 'relative' }}>
                      {showChapterIcons && <div style={{ position: 'absolute', top: '20px', right: '20px', opacity: 0.15 }}><ChapterIcon iconKey={iconKey} size={60} color={color.primary} /></div>}
                      <div style={{ fontSize: '11px', fontWeight: 700, color: color.secondary, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>Capitulo {chIdx + 1}</div>
                      <h2 style={{ fontSize: '24px', fontWeight: 800, color: color.primary, lineHeight: 1.3, fontFamily, position: 'relative', zIndex: 1 }}>{chapter.title}</h2>
                    </div>
                  ) : chapterLayout !== 'separator' ? (
                    <div className="ebook-no-break" style={{ marginBottom: '24px', borderBottom: `2px solid ${hasDeco('alt-backgrounds') && isEven ? 'rgba(0,0,0,0.06)' : color.bg}`, paddingBottom: '16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        {showChapterIcons && <div style={{ width: '50px', height: '50px', borderRadius: '14px', background: hasDeco('alt-backgrounds') && isEven ? '#fff' : color.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <ChapterIcon iconKey={iconKey} size={28} color={color.secondary} />
                        </div>}
                        <div>
                          <div style={{ fontSize: '11px', fontWeight: 700, color: color.secondary, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '4px' }}>Capitulo {chIdx + 1}</div>
                          <h2 style={{ fontSize: '22px', fontWeight: 800, color: color.primary, lineHeight: 1.3, fontFamily }}>{chapter.title}</h2>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {/* Content */}
                  <div style={{ textAlign: 'justify', color: hasDeco('alt-backgrounds') && isEven ? '#1e293b' : '#334155' }}>
                    {chapter.content.map((html, i) => (
                      <div key={i} dangerouslySetInnerHTML={{ __html: html }} style={{ marginBottom: '10px' }} className="ebook-content" />
                    ))}
                    {chapter.sections.map((section, sIdx) => (
                      <div key={sIdx} style={{ marginTop: '24px' }}>
                        {hasDeco('section-lines') && sIdx > 0 && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '20px 0' }}>
                            <div style={{ flex: 1, height: '1px', background: color.bg }} />
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: color.secondary, opacity: 0.4 }} />
                            <div style={{ flex: 1, height: '1px', background: color.bg }} />
                          </div>
                        )}
                        <h3 className="ebook-no-break" style={{ fontSize: '16px', fontWeight: 700, color: color.primary, marginBottom: '12px', paddingLeft: '12px', borderLeft: `3px solid ${color.secondary}` }}>{section.title}</h3>
                        {section.content.map((html, i) => (
                          <div key={i} dangerouslySetInnerHTML={{ __html: html }} style={{ marginBottom: '8px' }} className="ebook-content" />
                        ))}
                      </div>
                    ))}
                  </div>

                  {/* Footer */}
                  {footerDesign !== 'none' && (
                    <div style={{ marginTop: '30px', paddingTop: '8px', fontSize: '9px', display: 'flex', justifyContent: 'space-between', ...(footerDesign === 'colored' ? { borderTop: `2px solid ${color.secondary}`, color: color.secondary } : { borderTop: '1px solid #e2e8f0', color: '#94a3b8' }) }}>
                      <span style={footerDesign === 'branded' ? { fontWeight: 600, color: color.primary } : {}}>{footerDesign === 'simple' || footerDesign === 'colored' ? title : authorName}</span>
                      <span>{footerDesign === 'colored' ? <span style={{ background: color.secondary, color: '#fff', padding: '1px 8px', borderRadius: '8px', fontSize: '8px' }}>{pgNum}</span> : `Pagina ${pgNum} de ${totalPages}`}</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>

      <style>{`
        .ebook-content img { max-width: 100%; border-radius: 6px; margin: 10px 0; }
        .ebook-content ul, .ebook-content ol { padding-left: 22px; margin: 8px 0; }
        .ebook-content li { margin-bottom: 4px; }
        .ebook-content strong, .ebook-content b { color: #1e293b; }
        .ebook-content blockquote { border-left: 3px solid #e2e8f0; padding-left: 14px; margin: 14px 0; color: #64748b; font-style: italic; }
        .ebook-content a { color: ${color.secondary}; text-decoration: underline; }
        .ebook-content h2, .ebook-content h3 { color: ${color.primary}; }
        .ebook-content p { margin-bottom: 6px; }
      `}</style>
    </div>
  );
};

export default EbookPreview;
